import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';

import styles from './PlanHistoryChanges.module.scss';

interface IPlanHistoryChanges {
  data: IKnmHistoryItemChanges[];
}

export const PlanHistoryChanges = ({ data }: IPlanHistoryChanges) => {
  return (
    <div>
      {data.map((item, index) => (
        <div key={index} className={styles.Item}>
          <div className={styles.Title}>{item.title}</div>
          <div>
            {item.changesText.map((text, textIndex) => (
              <div className={styles.TextItem} key={textIndex}>
                {text}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
